import ResetPassword from "components/Login/ResetPassword"
import Layout from "hocs/layouts/Layout"
import Navbar from "components/navigation/Navbar"
import { useParams } from "react-router-dom"

function ResetPass(){

    const params = useParams()
    const uid = params.uid
    const token = params.token

    return(
        <Layout>
            <ResetPassword uid={uid&&uid} token={token&&token}/>            
        </Layout>
    )
}

export default ResetPass